import React, { Fragment, PureComponent } from 'react';
import { Input, Dropdown } from 'semantic-ui-react';

import * as ProdRecordHelpers from 'Pages/manageproduction/helpers/productionRecord';
import {
  ProductionRecordDetailFieldEnum as ProdRecordDetailFields,
} from 'Common/FieldEnum';
import { InputMode } from 'Common/FormEnum';

import { GridInputCell } from './GridInputCell';
import { GridCheckboxCell } from './GridCheckboxCell';

class ServedSectionRow extends PureComponent {
  renderServingLineLabel = (label) => ({
    color: 'blue',
    content: `${label.value}` ,  
    className: 'servingLine-label'
  });   

  onServingLineChange = (e, { value }) => {
    const { 
      [ProdRecordDetailFields.ArrayIndex]: index, 
      onInputChange,
    } = this.props;

    e.target.value = value;   
    e.target.name = ProdRecordDetailFields.ServingLine;
    e.target.index = index; 
    onInputChange(e);
  };

  render() {
    const {
      rfPrefix,
      [ProdRecordDetailFields.ArrayIndex]: index,
      collapsed,
      onInputChange,
      onServingLineChange,
      ...detailProps
    } = this.props;

    const isIngredient = ProdRecordHelpers.isDetailIngredient(detailProps);
    const servingLineOptions = [
      { key: '1', text: 'Serving Line 1', value: '1' },
      { key: '2', text: 'Serving Line 2', value: '2' },
      { key: '3', text: 'Serving Line 3', value: '3' },
      { key: '4', text: 'Serving Line 4', value: '4' },
    ];     

    return (
      <Fragment>
        <GridInputCell
          {...detailProps}
          inputProps={{
            name: ProdRecordDetailFields.Served,
            onChange: onInputChange,
            value: detailProps[ProdRecordDetailFields.Served],
            'data-index': index,
          }}
          mode={InputMode.Integer}
        />
        {!collapsed && (
          <Fragment>
            <GridInputCell
              {...detailProps}
              inputProps={{
                name: ProdRecordDetailFields.ServedPreK,
                onChange: onInputChange,
                value: detailProps[ProdRecordDetailFields.ServedPreK],
                'data-index': index,
              }}
              mode={InputMode.Integer}
            />
            <GridInputCell
              {...detailProps}
              inputProps={{
                name: ProdRecordDetailFields.ServedAlacarte,
                onChange: onInputChange,
                value: detailProps[ProdRecordDetailFields.ServedAlacarte],
                'data-index': index,
              }}
              mode={InputMode.Integer}
            />
            <GridInputCell
              {...detailProps}
              inputProps={{
                name: ProdRecordDetailFields.ServedAdult,
                onChange: onInputChange,
                value: detailProps[ProdRecordDetailFields.ServedAdult],
                'data-index': index,
              }}
              mode={InputMode.Integer}
            />
            <GridInputCell
              {...detailProps}
              inputProps={{
                name: ProdRecordDetailFields.Leftover,
                onChange: onInputChange,
                value: detailProps[ProdRecordDetailFields.Leftover],
                'data-index': index,
              }}
              mode={InputMode.Integer}
            />
            <GridInputCell
              {...detailProps}
              inputProps={{
                name: ProdRecordDetailFields.Discard,
                onChange: onInputChange,
                value: detailProps[ProdRecordDetailFields.Discard],
                'data-index': index,
              }}
              mode={InputMode.Integer}
            />
            {isIngredient ? (
              <Input className="menu-input" disabled value="" />
            ) : (
              <Input
                className="menu-input"
                value={ProdRecordHelpers.computeReimbServedTotal(detailProps)}
                fluid
                disabled
              />
            )}
            <GridCheckboxCell
              {...detailProps}
              inputProps={{
                name: ProdRecordDetailFields.AvailableReserve,
                onChange: onInputChange,
                checked: detailProps[ProdRecordDetailFields.AvailableReserve],
                'data-index': index,
              }}
            />
            <Dropdown 
              className="menu-input"
              placeholder="Serving Lines"
              multiple selection
              options={servingLineOptions}
              renderLabel={this.renderServingLineLabel}
              onChange={this.onServingLineChange}
              defaultValue={detailProps[ProdRecordDetailFields.ServingLine]}
            />
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export { ServedSectionRow };


// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/ServedSectionRow.js